import React from 'react';
import { withRouter } from 'react-router-dom';
import {Button, Col} from 'react-bootstrap';

import './nomatch.css';
import { withTranslation } from 'react-i18next';

const gobackstyle = {
    fontSize:"12px", padding: "10px 25px", background: "transparent", color: "#555", fontWeight: "600", textTransform: "uppercase"
}

class NoMatchComponent extends React.Component{
    _isMounted = false;
    constructor(props){
        super(props);
        this.state = {
            
        }
    }
      
    componentDidMount(){
        this._isMounted = true;

        if(this._isMounted){
            this.props.history.push("/");
        }
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    render(){
        return (<>
            
            <Col xs={12} md={6} className="nomatch-content centered text-center">
                <h1 className="text-center">404 NOT FOUND</h1>
                <Col>
                    <Button color="secondary" style={gobackstyle} onClick={() => this.props.history.goBack()}>{this.props.t('GO_BACK')}</Button>
                </Col>
            </Col>
        </>);
    }
}

export default withTranslation()(withRouter(NoMatchComponent));